import { render, staticRenderFns } from "./DashboardShipperLite.vue?vue&type=template&id=3a486abf"
import script from "./DashboardShipperLite.vue?vue&type=script&lang=js"
export * from "./DashboardShipperLite.vue?vue&type=script&lang=js"
import style0 from "./DashboardShipperLite.vue?vue&type=style&index=0&id=3a486abf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports